import { createApp } from '@wu/widget-core';
import { meta } from '../constants';
import { Widget } from './widget';

export const createFeed = () => {
  return createApp(meta, Widget);
};
